import { proxy } from 'valtio'

export const windowSizeState = proxy({
  currentWidth: window.innerWidth,
  currentHeight: window.innerHeight,
  get ipadMini() {
    return this.currentWidth <= 1024 && this.currentHeight > 1000
  },
  get mobileMode() {
    return this.currentWidth <= 920
  },
  get phoneMode() {
    return this.currentWidth <= 580
  },

  get isMobileRotate() {
    return this.currentWidth < 580
  },

  get vh() {
    return this.currentHeight
  }
})

let timeoutID = setTimeout(() => {}, 1000)

const handleResize = () => {
  windowSizeState.currentWidth = window.innerWidth
  windowSizeState.currentHeight = window.innerHeight
}

const debouncedHandleResize = () => {
  clearTimeout(timeoutID)
  timeoutID = setTimeout(handleResize, 250)
}

window.addEventListener('resize', debouncedHandleResize)
